module.exports = __webpack_public_path__ + "static/media/zoom-out.d470c9d2.png";